module.exports = __webpack_public_path__ + "img/banner.19069c1d.png";